import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { useFormik } from 'formik';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const filterTypes = [
  { label: 'Begins With', value: 'begin_with' },
  { label: 'Contains', value: 'contains' },
  { label: "Doesn't contains", value: 'does_not_contains' },
  { label: 'Is Equal To', value: 'is_equal' },
  { label: 'Is Not Equal To', value: 'is_not_equal' },
  { label: 'Ends With', value: 'ends_with' },
];

const GlobalFilters = ({
  setFilters,
  initialValues,
  filters,
  isSearching = false,
  setOpenFilter,
  openFilter,
}) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleSubmitForm = async (values) => {
    const { filter } = values;
    let filteredArray = filter.filter(
      (value) =>
        value[Object.keys(value)[0]] || value[Object.keys(value)[0]] === 0,
    );

    const isDate = filteredArray.filter((v) => v['date']);

    if (isDate && isDate.length > 0 && !isDate[0]['date']['from']) {
      const mutuatedArray = filteredArray.filter(
        (_, index) => index !== filteredArray?.length - 1,
      );

      setFilters(mutuatedArray);
    } else {
      setFilters(filteredArray);
    }

    setOpenFilter(!openFilter);
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });

  const DATE_FILTER_INDEX = formik.values?.filter?.findIndex(
    (value) => Object.keys(value)[0] === 'date',
  );

  const handleClearFilter = () => {
    formik.resetForm();
    setStartDate(null);
    setEndDate(null);
    setFilters([]);
  };

  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    formik.setFieldValue(
      `filter[${DATE_FILTER_INDEX}].date.from`,
      moment(start).format('YYYY-MM-DD'),
    );
    formik.setFieldValue(
      `filter[${DATE_FILTER_INDEX}].date.to`,
      moment(end).format('YYYY-MM-DD'),
    );
  };

  const setToday = () => {
    formik.setFieldValue(
      `filter[${DATE_FILTER_INDEX}].date.from`,
      moment().format('YYYY-MM-DD'),
    );
    formik.setFieldValue(
      `filter[${DATE_FILTER_INDEX}].date.to`,
      moment().format('YYYY-MM-DD'),
    );
  };
  const setYesterday = () => {
    formik.setFieldValue(
      `filter[${DATE_FILTER_INDEX}].date.from`,
      moment().subtract(1, 'days').format('YYYY-MM-DD'),
    );
    formik.setFieldValue(
      `filter[${DATE_FILTER_INDEX}].date.to`,
      moment().subtract(1, 'days').format('YYYY-MM-DD'),
    );
  };
  const setSevenDays = () => {
    formik.setFieldValue(
      `filter[${DATE_FILTER_INDEX}].date.from`,
      moment().subtract(6, 'days').format('YYYY-MM-DD'),
    );
    formik.setFieldValue(
      `filter[${DATE_FILTER_INDEX}].date.to`,
      moment().format('YYYY-MM-DD'),
    );
  };
  const setThirtyDays = () => {
    formik.setFieldValue(
      `filter[${DATE_FILTER_INDEX}].date.from`,
      moment().subtract(29, 'days').format('YYYY-MM-DD'),
    );
    formik.setFieldValue(
      `filter[${DATE_FILTER_INDEX}].date.to`,
      moment().format('YYYY-MM-DD'),
    );
  };
  const setThisMonth = () => {
    formik.setFieldValue(
      `filter[${DATE_FILTER_INDEX}].date.from`,
      moment().startOf('month').format('YYYY-MM-DD'),
    );
    formik.setFieldValue(
      `filter[${DATE_FILTER_INDEX}].date.to`,
      moment().endOf('month').format('YYYY-MM-DD'),
    );
  };
  const setLastMonth = () => {
    formik.setFieldValue(
      `filter[${DATE_FILTER_INDEX}].date.from`,
      moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
    );
    formik.setFieldValue(
      `filter[${DATE_FILTER_INDEX}].date.to`,
      moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
    );
  };
  const setDefault = () => {
    formik.setFieldValue(`filter[${DATE_FILTER_INDEX}].date.from`, '');
    formik.setFieldValue(`filter[${DATE_FILTER_INDEX}].date.to`, '');
  };

  const handleChangeDateFilterType = (type) => {
    switch (type) {
      case 'Today':
        return setToday();
      case 'Yesterday':
        return setYesterday();
      case 'Last 7 Days':
        return setSevenDays();
      case 'Last 30 Days':
        return setThirtyDays();
      case 'This Month':
        return setThisMonth();
      case 'Last Month':
        return setLastMonth();
      case 'Custom':
        return;
      default:
        return setDefault();
    }
  };

  useEffect(() => {
    if (DATE_FILTER_INDEX === -1) {
      return false;
    } else {
      handleChangeDateFilterType(
        formik.values.filter[DATE_FILTER_INDEX].a_filter_type,
      );
    }
  }, [formik.values.filter[DATE_FILTER_INDEX].a_filter_type]);

  const handleClearParticularFilter = (filterToRemove) => {
    const requiredIndex = formik.values?.filter?.findIndex(
      (value) => Object.keys(value)[0] === Object.keys(filterToRemove)[0],
    );

    if (requiredIndex === -1) {
      return false;
    }

    if (Object.keys(filterToRemove)[0] === 'date') {
      formik.setFieldValue(`filter[${requiredIndex}].a_filter_type`, '');
      formik.setFieldValue(`filter[${requiredIndex}].date.from`, '');
      formik.setFieldValue(`filter[${requiredIndex}].date.to`, '');
    } else {
      formik.setFieldValue(`filter[${requiredIndex}].a_filter_type`, '');
      formik.setFieldValue(
        `filter[${requiredIndex}][${Object.keys(filterToRemove)[0]}]`,
        '',
      );
    }

    formik.submitForm();
  };

  const prepareFilterOptions = (index, filterProps) => {
    const { filterOptions, shouldFilterOptionDisabled } = filterProps;
    if (filterOptions && filterOptions.length > 0) {
      return (
        <select
          name={`filter[${index}].a_filter_type`}
          value={formik.values.filter[index].a_filter_type}
          className="form-control   form-control-sm w-max-140"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          disabled={shouldFilterOptionDisabled}
        >
          <option value="">Filter type</option>
          {filterOptions.map(({ label, value }, index) => (
            <option value={value} key={index}>
              {label}
            </option>
          ))}
        </select>
      );
    }

    return (
      <select
        disabled={shouldFilterOptionDisabled}
        name={`filter[${index}].a_filter_type`}
        value={formik.values.filter[index].a_filter_type}
        className="form-control   form-control-sm w-max-140"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      >
        <option value="">Filter type</option>
        {filterTypes.map(({ label, value }, index) => (
          <option value={value} key={index}>
            {label}
          </option>
        ))}
      </select>
    );
  };

  const prepareFilterInput = (index, filterProps, filterKey) => {
    const { type, selectOptions, placeholder } = filterProps;

    if (type === 'select') {
      if (selectOptions && selectOptions.length > 0) {
        return (
          <select
            className="form-control   form-control-sm "
            name={`filter[${index}].${filterKey}`}
            placeholder={`Enter ${filterKey}...`}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.filter[index][filterKey]}
          >
            <option value="">{placeholder}</option>
            {selectOptions.map((option, index) => (
              <option value={option.value || option.isoCode} key={index}>
                {option.label || option.name}
              </option>
            ))}
          </select>
        );
      }
    }

    if (type === 'text') {
      return (
        <input
          type="text"
          className="form-control   form-control-sm"
          name={`filter[${index}].${filterKey}`}
          placeholder={placeholder}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.filter[index][filterKey]}
        />
      );
    }
    if (type === 'number') {
      return (
        <input
          type="number"
          step="any"
          className="form-control   form-control-sm"
          name={`filter[${index}].${filterKey}`}
          placeholder={placeholder}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.filter[index][filterKey]}
        />
      );
    }

    if (type === 'date') {
      return (
        <DatePicker
          disabled={formik.values.filter[index].a_filter_type !== 'Custom'}
          placeholderText={placeholder}
          className="form-control  form-control-sm"
          selected={startDate}
          onChange={onChange}
          startDate={startDate}
          endDate={endDate}
          selectsRange
          monthsShown={2}
          isClearable={true}
          dateFormat="yyyy-MM-dd"
        />
      );
    }
  };

  const shouldFilterDisabled =
    !!formik.values?.filter?.[DATE_FILTER_INDEX]['date']['from'] ||
    formik.values?.filter?.some(
      (val, index) =>
        index !== formik.values?.filter?.length - 1 &&
        val[Object.keys(val)[0]] !== '',
    );

  return (
    <form className="search_box border-radius-5" onSubmit={formik.handleSubmit}>
      <div className="d-flex gap-3">
        <div className="w-100">
          <div className="d-flex justify-content-between mb-1">
            {filters && filters.length > 0 ? (
              <>
                <div className="d-flex filter_badge">
                  {filters.map((filter) => (
                    <>
                      <span className="d-flex  mr-2 align-items-center    btn-primary  btn-sm">
                        <small className="uppercase font-600 mr-1 text-black">
                          {filter?.label ?? ''}
                        </small>
                        <span className="pointer font-15">
                          <FontAwesomeIcon
                            icon={faCircleXmark}
                            onClick={() => handleClearParticularFilter(filter)}
                          />
                        </span>
                      </span>
                    </>
                  ))}
                </div>
                <span className="d-flex ">
                  <small className="text-black d-flex align-items-center ">
                    <b>Clear {filters.length} filter(s) </b>
                    <button
                      className="pointer font-15"
                      style={{ backgroundColor: 'transparent' }}
                    >
                      <FontAwesomeIcon
                        icon={faCircleXmark}
                        onClick={() => handleClearFilter()}
                      />
                    </button>
                  </small>
                </span>
              </>
            ) : null}
          </div>
          <div
            className="mb-0 d-flex flex-column gutter-3"
            controlId="formBasicEmail"
          >
            {initialValues &&
              initialValues.filter &&
              initialValues.filter.length > 0 &&
              initialValues.filter.map((filter, index) => (
                <div className="d-flex w-100 gutter-3">
                  {prepareFilterInput(index, filter, Object.keys(filter)?.[0])}
                  {prepareFilterOptions(index, filter)}
                </div>
              ))}
            <button
              type="submit"
              style={{
                position: 'absolute',
                bottom: '16px',
                width: '140px',
                height: '34px',
              }}
              disabled={isSearching || !shouldFilterDisabled}
              className="d-flex  justify-content-center  btn btn-primary align-items-center font-600"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default GlobalFilters;
